import styled from "styled-components";
import { SubHeading, CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { breakpoints, device } from "../../../utils/responsive_utilities";
import { white, codGrey, deepCoveDark } from '../../../components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;

  background-color: ${deepCoveDark};
  ${styledFont("Graphie")}
  padding: 0 0 3rem;
  box-sizing: border-box;
`;

export const Wrapper = styled.div`
  width: 90%;
  margin: 2rem auto 0;
  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;

export const ContentWrapper = styled.div`
  width: 34.3rem;
  margin: 0 auto;
  @media (min-width: ${breakpoints.lg}px) {
    /* flex: 1; */
    width: 47.1rem;
  }
  @media ${device.TabletLandscape}{
    width: 38.6rem;
  }
  @media ${device.Tablet}, ${device.PhoneTabletLandscape}{
    width: 48.5rem;
  }

`;

export const Content = styled.p`
  margin-top: 1.6rem;
  color: ${white};
  ${styledFont('Graphie', 1.6, 2.4, 4)};
  @media (min-width: ${breakpoints.md}px) {
    ${styledFont('Graphie', 2, 2.8, 4)};
  }
`;

export const ImageWrapper = styled.div`
  min-width: 25rem;
  margin: 0 auto;
  > img {
    height: 100%;
    width: 100%;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: 65.4rem;
    height: 45.5rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex: 2;
    max-width: 72.1rem;
    max-height: 50.2rem;
  }
  @media ${device.TabletLandscape}{
    width: 62.9rem; 
    height: 43.7rem;
    flex: unset;
  }
`;

export const HeadingText = styled.h2`
  color: ${white};
  margin: auto;
  padding-top: 4rem;
  text-align: left;
  ${styledFont('Graphie', 2.8, 3.2, 7)};
  @media (min-width: ${breakpoints.md}px) {
    ${styledFont('Graphie', 3.2, 3.8, 7)};
  }
  @media ${device.Desktop} {
    ${styledFont('Graphie', 4, 4.8, 7)};
    padding-top: 6rem;
  }
`;

export const SubHeadingText = styled(SubHeading)`
  width: 100%;
  color: ${white};
  padding-top: 0.5rem;
  ${styledFont('Graphie', 1.6, 2, 6)};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont('Graphie', 2, 2.4, 6)};
  }
`;

export const WaveWrapper = styled.div`
  background: ${white};

  img {
    display: block;
    width: 100%;
  }

`;

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding: 5.2rem 0 6.8rem 0;
  > div {
    width: 22rem;
  }
  @media (min-width: ${breakpoints.md}px) {
    padding: 3.2rem 0 6rem 0;
    > div {
      width: 25.2rem;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 5.5rem 0 6.5rem 0;
  }
  @media ${device.Desktop} {
    padding: 3rem 0 7rem 0;
  }
`;

